// extracted by mini-css-extract-plugin
export default {"container":"_faq_container__IEalv","card":"_faq_card__Hi3DZ"};